var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QualityControl',{attrs:{"profile":_vm.profile,"user":_vm.user}})}
var staticRenderFns = []

export { render, staticRenderFns }